import { z } from 'zod';

export const discountRequestSchema = z.object({
  currentHashrate: z
    .string()
    .trim()
    .min(1, { message: 'error.required' })
    .refine((value) => {
      const numericValue = Number(value);
      return Number.isFinite(numericValue) && numericValue > 0;
    }, {
      message: 'marketing.discount.form.hashrate.error.invalid',
    }),
  name: z
    .string()
    .trim()
    .min(1, { message: 'error.required' }),
  email: z
    .string()
    .trim()
    .min(1, { message: 'error.required' })
    .email({ message: 'marketing.discount.form.email.error' }),
  contact: z
    .string()
    .trim()
    .optional(),
});

export type DiscountRequestFormValues = z.infer<typeof discountRequestSchema>;

